import { AccountInfo } from "@azure/msal-browser";

const LOGIN_HINT_KEY = "preppa.kitchen.deviceLoginHint";
const DEVICE_APP_ROLE = "device.app.access";
const SWITCH_ACCOUNT_PARAM = "switchaccount";


function hasDeviceAppRole(account: AccountInfo): boolean {
  const roles =
    (account.idTokenClaims as { roles?: string[] } | undefined)?.roles || [];
  return roles.some((role) => role.toLowerCase() === DEVICE_APP_ROLE);
}

export function isAccountSwitchRequested(): boolean {
  return new URLSearchParams(window.location.search).has(SWITCH_ACCOUNT_PARAM);
}

export function getDeviceLoginHint(): string | undefined {
  if (isAccountSwitchRequested()) {
    return undefined;
  }

  try {
    return localStorage.getItem(LOGIN_HINT_KEY) || undefined;
  } catch {
    return undefined;
  }
}

export function rememberDeviceAccount(account: AccountInfo): void {
  if (!account.username || !hasDeviceAppRole(account)) {
    return;
  }

  try {
    localStorage.setItem(LOGIN_HINT_KEY, account.username);
  } catch {
    /* ignore */
  }
}

export function clearDeviceLoginHint(): void {
  try {
    localStorage.removeItem(LOGIN_HINT_KEY);
  } catch {
    /* ignore */
  }
}
